import { useEffect } from 'preact/hooks'

interface Props {
    id: string
    page: number
}

const setup = ({ id, page }: Props) => {
    const gallery = document.querySelector(`#${id}`)

    const viewHeight = globalThis.innerHeight
    const galleryHeight = gallery?.getBoundingClientRect().height || 0

    const optimalThreshold = viewHeight / galleryHeight / 2

    const options = {
        threshold: optimalThreshold,
    }

    const handleIntersection = (
        entries: IntersectionObserverEntry[],
        _observer: IntersectionObserver,
    ) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                const currentUrl = window.location.href
                const url = new URL(currentUrl)

                url.searchParams.set('page', String(page))
                window.history.replaceState({}, '', url)
            }
        })
    }

    const observer = new IntersectionObserver(handleIntersection, options)

    if (!gallery) {
        console.warn(
            'Missing necessary gallery attributes. It will not work as intended. Necessary elements:',
            { gallery },
        )
        return
    }

    observer.observe(gallery)
}

function InfiniteScrollJs({ id, page }: { id: string; page: number }) {
    useEffect(() => {
        setup({ id, page })
    }, [id, page])

    return null
}

export default InfiniteScrollJs
